<template>
  <div>
    <label :for="labelFor" v-if="label" class="label-text">{{ label }}</label>
    <select @input="$emit('input', $event.target.value)" class="select-control" :disabled="disabled">
      <option :value="null" :key="-1">{{ nullValueName }}</option>
      <option v-for="(item, index) in options" :value="item.value" :key="index">
        {{ item.label }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  name: "SelectInputComponent",
  props: {
    labelFor: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
    nullValueName: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/field.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/color.scss";

.select-control {
  border: 1px solid rgb(222, 222, 222);
  border-radius: $field-border-radius;
  color: $dark-100;
  font-size: $font-size-md;
  padding: 9px 10px;
  text-transform: capitalize;
  width: 100%;
  &:hover {
    cursor: pointer;
  }

  &:disabled {
    background-color: $light-200;
  }
}

.select-control::placeholder {
  font-size: 15px;
}

.label-text {
  font-weight: $font-weight-normal-2;
  font-size: $font-size-md;
  margin-bottom: 10px;
}

.select-control:focus {
  outline: none;
}
</style>
